import { z } from 'zod';

/* ------------------------------------------------------------------ */
/*  Domain enums                                                       */
/* ------------------------------------------------------------------ */

const DomainKeyEnum = z.enum([
  'userManagement',
  'vulnerabilityScanning',
  'mcpServerManagement',
  'agentServerManagement',
  'auditLog',
]);
type DomainKey = z.infer<typeof DomainKeyEnum>;

const LevelEnum = z.enum(['none', 'view', 'full']);
type Level = z.infer<typeof LevelEnum>;

/* ------------------------------------------------------------------ */
/*  Core schemas                                                       */
/* ------------------------------------------------------------------ */

export const PermissionsSchema = z.record(DomainKeyEnum, LevelEnum);

const RoleSchema = z.object({
  roleId: z.string(),
  key: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isSystem: z.boolean(),
  permissions: PermissionsSchema,
  memberCount: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Role = z.infer<typeof RoleSchema>;

/* ------------------------------------------------------------------ */
/*  Response wrappers                                                  */
/* ------------------------------------------------------------------ */

export const RoleListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(RoleSchema),
});

export const RoleMutationResponseSchema = z.object({
  success: z.boolean(),
  data: RoleSchema,
});

/* ------------------------------------------------------------------ */
/*  Mutation payloads (for type-safe call-sites)                       */
/* ------------------------------------------------------------------ */

export interface CreateRoleBody {
  name: string;
  description?: string;
  permissions: Record<DomainKey, Level>;
}

export interface UpdateRoleBody {
  name?: string;
  description?: string;
  permissions?: Record<DomainKey, Level>;
}
